export default function getResource(label, vars = []) {
    const resources = {
        title: 'Save on Your Purchase',
        creditCardTitle: 'Credit Card Rewards',
        creditCardPrimaryText: `Up to $${vars[0]}`,
        creditCardSecondaryText: 'available',
        creditCardButtonText: 'Apply in Basket',
        creditCardLinkText: 'Learn more',
        rougeRewardsTitle: 'Rouge Rewards',
        rougeRewardsPrimaryText: `${vars[0]} off`,
        rougeRewardsSecondaryText: 'available',
        rougeRewardsExpiresText: `Expires ${vars[0]}`,
        rougeRewardsButtonText: 'Apply',
        rougeRewardsLinkText: 'Learn more',
        biCashTitle: 'Beauty Insider Cash',
        biCashPrimaryText: `Get $${vars[0]} off`,
        biCashSecondaryText: 'available',
        biCashButtonText: 'Apply',
        biCashButtonTextChoose: 'Choose',
        biCashButtonTextApplied: 'Applied',
        biCashLinkText: 'Learn more',
        rougeBadge: 'ROUGE EXCLUSIVE',
        biCashValueOff: `${vars[0]} off`,
        biCashUpToOff: `Up to ${vars[0]} off`,
        biCashForPoints: `for ${vars[0]} points`,
        biCashTwoPromotionsPrefix: `${vars[0]} points = `,
        biCashTwoPromotionsSuffix: `${vars[0]} off`,
        ctaApplied: 'Applied',
        ctaRemove: 'Remove',
        biCashPoints: 'points',
        biCashOff: 'off',
        biCashUpTo: 'Up to',
        biCashFor: 'for',

        // BEP-522 error modal strings
        errorTitle: 'Error',
        okButtonText: 'OK',
        emptyBasketError: 'Merchandise, excluding gift cards, must be included in your order to qualify for this offer.',
        insufficientBasketWarning: `You have ${vars[0]} remaining on the Rouge Reward. Rouge Reward is one-time use only and expires within 90 days of redemption. If you wish to use the full value, add more items to your basket or remove the Rouge Reward and save for a future purchase.`
    };

    return resources[label];
}
